import axios from 'axios'
import store from '@/store'
// import { bus as $bus } from '@/main'
import { removeUserErrorStatuses } from '@/const'

export const baseURL = ({ v = 2 } = {}) => `/api/admin/v${v}/`
export const collectOrdersBaseURL = '/api/manufacture/v1/'

const http = axios.create({
  baseURL: baseURL()
})

http.interceptors.response.use(r => {
  return r.data.data ? r.data.data : r.data
}, e => {
  console.log('Server error ' + e)
  if (e.response) {
    const errCode = e.response.data.code
    const errMsg = e.response.data.message
    if (removeUserErrorStatuses.includes(errCode)) {
      if (e.config && ['logout', 'auth'].includes(e.config.url)) {
        return Promise.reject(e.response)
      }
      store.commit('pageLoader/SET_LOADING', false)
      store.dispatch('users/logout')
    } else if (errCode === 'shifts_already_opened') {
      store.commit('serverErrors/ADD_ERROR', errMsg.map(msgObj => {
        return `На время ${msgObj.shift_datetime} невозможно открыть смену.
        У курьера с id ${msgObj.courier_dosta_id} уже была открыта смена в этот день.`
      }))
    } 
    // else if (
    //   errCode === 'permission_denied' && e.response.config.method === 'get' &&
    //   !(e.config && e.config.baseURL === collectOrdersBaseURL)
    // ) {
    //   $bus.$emit('error-403')
    //   return Promise.reject(e.response)
    // } 
    else if (errMsg) {
      store.commit('serverErrors/ADD_ERROR', errMsg)
    }
    return Promise.reject(e.response)
  }
  return Promise.reject(e)
})

http.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Token ${token}`
    if (config.v3) {
      config.baseURL = baseURL({ v: 3 })
    } else if (!config.baseURL) {
      config.baseURL = baseURL()
    }
    }
    return config
  },
  error => Promise.reject(error)
)

export default http
